import { createFileRoute } from '@tanstack/react-router';
import { OperatorLayout } from '@/features/operator/operator-layout';
import { requireSession } from '@hlt/web-kit/shell';

export const Route = createFileRoute('/operator')({
    beforeLoad: async ({ context, location }) => await requireSession(context.queryClient, location.href),
    component: OperatorLayout,
});
